import React from "react";
import { Loader, DepositForm, PageLayout } from "src/components";
import { useDepositWithdrawContext } from "src/contexts";

const DepositPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError } = useDepositWithdrawContext();

  if (widgetDataLoading || widgetDataError) {
    return <Loader />;
  }

  return (
    <PageLayout>
      <DepositForm />
    </PageLayout>
  );
};

export default DepositPage;
